import { Component } from '@angular/core';
import { toUniversalDateString } from '@assetaccountant/core';
import { DepreciationMethodDtoWithKey } from '@assetaccountant/core/models/depreciation-method';
import { CA_TAX_REGIME_ID } from '@assetaccountant/core/models/regime-api-model';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { DepreciationMethodModifier } from '../depreciation-method-modifier.component';

/**
 * Class 29 (Manufacturing Equipment) applies only to M&P property acquired
 * before 2016-01-01 (ITR Reg 1100 Sch II). Assets acquired on or after that
 * date should use Class 53 (pool).
 */
export function isDateValidForClass29(acquisitionDate: string | null | undefined): boolean {
  const d = toUniversalDateString(acquisitionDate);
  return !d || d < '2016-01-01';
}

@Component({
  selector: 'app-ca-class29-method-modifier',
  template: '',
  standalone: false,
})
export class CaClass29MethodModifierComponent implements DepreciationMethodModifier {
  static readonly regimeId = CA_TAX_REGIME_ID;

  readonly isVisible = false;

  applyFilter(
    depreciationMethods$: Observable<DepreciationMethodDtoWithKey[]>,
    acquisitionDate$: Observable<string | null>,
  ): Observable<DepreciationMethodDtoWithKey[]> {
    return combineLatest([depreciationMethods$, acquisitionDate$]).pipe(
      map(([methods, acquisitionDate]) =>
        isDateValidForClass29(acquisitionDate) ? methods : methods.filter(dm => dm.code !== 'C29'),
      ),
    );
  }
}
